import { create } from "zustand";
import useApi from "../helper/apiConfig";
import { apiRoutes } from "../helper/constant";

// Zustand store definition
export const useLoyaltyTierStore = create((set) => ({
  // get
  loyaltyTierData: null,
  isLoading: false,
  isError: false,
  isSuccess: false,

  // get cutOnXp
  loyaltyTierCutOnXpData: null,
  isCutOnXpLoading: false,
  isCutOnXpError: false,
  isCutOnXpSuccess: false,

  // get tier form data
  loyaltyTierFormData: null,
  isLoyaltyTierFormLoading: false,
  isLoyaltyTierFormError: false,
  isLoyaltyTierFormSuccess: false,

  // post tier form data
  postLoyaltyTierFormData: null,
  isPostLoyaltyTierFormLoading: false,
  isPostLoyaltyTierFormError: false,
  isPostLoyaltyTierFormSuccess: false,
  postLoyaltyTierFormErrorData: null,

  // put tier form data
  putLoyaltyTierFormData: null,
  isPutLoyaltyTierFormLoading: false,
  isPutLoyaltyTierFormError: false,
  isPutLoyaltyTierFormSuccess: false,
  putLoyaltyTierFormErrorData: null,

  // delete tier form data
  deleteLoyaltyTierFormData: null,
  isDeleteLoyaltyTierFormLoading: false,
  isDeleteLoyaltyTierFormError: false,
  isDeleteLoyaltyTierFormSuccess: false,
  setState: (newState) => set((state) => ({ ...state, ...newState })),
}));

// Custom hooks that uses useApi and Zustand store together
export const useFetchLoyaltyTier = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const fetchLoyaltyTier = async (queryParams = {}) => {
    setState({ isLoading: true, isError: false, isSuccess: false });

    try {
      const query = new URLSearchParams(queryParams).toString();
      const response = await loyaltyTierApi.get(
        `${apiRoutes.tiersOnboarding.tierList}/${sessionStorage.getItem(
          "instanceId"
        )}?${query}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({ loyaltyTierData: tierData, isSuccess: true });
    } catch (error) {
      setState({ isError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isLoading: false });
    }
  };

  return fetchLoyaltyTier;
};

export const usePostLoyaltyTier = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const postLoyaltyTier = async (data) => {
    setState({
      isPostLoyaltyTierFormLoading: true,
      isPostLoyaltyTierFormError: false,
      isPostLoyaltyTierFormSuccess: false,
    });

    try {
      const response = await loyaltyTierApi.post(
        `${apiRoutes.tiersOnboarding.tierList}/${sessionStorage.getItem(
          "instanceId"
        )}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({
        postLoyaltyTierFormData: tierData,
        isPostLoyaltyTierFormSuccess: true,
      });
    } catch (error) {
      console.log("error: ", error);
      setState({
        isPostLoyaltyTierFormError: true,
        postLoyaltyTierFormErrorData: error.response.data.status.message,
      });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isPostLoyaltyTierFormLoading: false });
    }
  };

  return postLoyaltyTier;
};

export const usePutLoyaltyTier = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const putLoyaltyTier = async (tierId, data) => {
    setState({
      isPutLoyaltyTierFormLoading: true,
      isPutLoyaltyTierFormError: false,
      isPutLoyaltyTierFormSuccess: false,
    });

    try {
      const response = await loyaltyTierApi.put(
        `${apiRoutes.tiersOnboarding.tierList}/${sessionStorage.getItem(
          "instanceId"
        )}/${tierId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({
        putLoyaltyTierFormData: tierData,
        isPutLoyaltyTierFormSuccess: true,
      });
    } catch (error) {
      setState({
        isPutLoyaltyTierFormError: true,
        putLoyaltyTierFormErrorData: error.response.data.status.message,
      });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isPutLoyaltyTierFormLoading: false });
    }
  };

  return putLoyaltyTier;
};

export const useDeleteLoyaltyTier = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const deleteLoyaltyTier = async (tierId) => {
    setState({
      isDeleteLoyaltyTierFormLoading: true,
      isDeleteLoyaltyTierFormError: false,
      isDeleteLoyaltyTierFormSuccess: false,
    });

    try {
      const response = await loyaltyTierApi.delete(
        `${apiRoutes.tiersOnboarding.tierList}/${sessionStorage.getItem(
          "instanceId"
        )}/${tierId}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({
        deleteLoyaltyTierFormData: tierData,
        isDeleteLoyaltyTierFormSuccess: true,
      });
    } catch (error) {
      setState({ isDeleteLoyaltyTierFormError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isDeleteLoyaltyTierFormLoading: false });
    }
  };

  return deleteLoyaltyTier;
};

export const useFetchLoyaltyTierCutOnXp = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const fetchLoyaltyTier = async () => {
    setState({
      isLoyaltyTierFormLoading: true,
      isLoyaltyTierFormError: false,
      isLoyaltyTierFormSuccess: false,
    });

    try {
      const response = await loyaltyTierApi.get(
        `${
          apiRoutes.tiersOnboarding.tierCutOnXP
        }/?instanceid=${sessionStorage.getItem("instanceId")}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({
        loyaltyTierCutOnXpData: tierData,
        loyaltyTierFormData: tierData,
        isLoyaltyTierFormSuccess: true,
      });
    } catch (error) {
      setState({ isLoyaltyTierFormError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isLoyaltyTierFormLoading: false });
    }
  };

  return fetchLoyaltyTier;
};

export const useFetchLoyaltyTierById = () => {
  const loyaltyTierApi = useApi(process.env.REACT_APP_BASE_URL);
  const { setState } = useLoyaltyTierStore();

  const fetchLoyaltyTierById = async (queryParams = {}) => {
    setState({
      isLoyaltyTierFormLoading: true,
      isLoyaltyTierFormError: false,
      isLoyaltyTierFormSuccess: false,
    });

    try {
      const query = new URLSearchParams(queryParams).toString();
      const response = await loyaltyTierApi.get(
        `${apiRoutes.tiersOnboarding.tierList}/${sessionStorage.getItem(
          "instanceId"
        )}?${query}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
          },
        }
      );
      const { data: tierData } = response;
      setState({
        loyaltyTierFormData: tierData?.docs[0],
        isLoyaltyTierFormSuccess: true,
      });
    } catch (error) {
      setState({ isLoyaltyTierFormError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isLoyaltyTierFormLoading: false });
    }
  };

  return fetchLoyaltyTierById;
};
